import { useQuery } from "@tanstack/react-query";
import { DraftDto, getDraftById } from "../actions/getDraftById.actions";

type Options = {
  enabled?: boolean;
};

export const useDraftByIdQuery = (draftId?: string, options: Options = {}) => {
  const { enabled = true } = options;

  return useQuery<DraftDto, Error>({
    queryKey: ["page-builder", "drafts", "byId", draftId],
    queryFn: () => {
      if (!draftId) throw new Error("Missing draftId");
      return getDraftById(draftId);
    },
    enabled: enabled && !!draftId,
    staleTime: 15_000,
    retry: 1,
  });
};
